/**
 * Function used to get the full URL based on the given partial URL path elements.
 */
export default function getPath(...pathElements: string[]): string {
    const newPath = pathElements
      .filter((path) => path.length)
      .join("/")
      .replace(/(https?:\/\/)|(\/)+/g, "$1$2");
  
    return newPath.lastIndexOf("/") === newPath.length - 1 && newPath !== "/"
      ? newPath.substring(0, newPath.length - 1)
      : newPath;
  }


export const isSelectedTab = (url: string) => {
    return window.location.pathname.toLowerCase() === url.toLowerCase();
  };